<template>
  <div>
    <div class="mx-auto max-w-7xl px-6 lg:px-8 place-items-center">
      <div class="mx-auto max-w-2xl lg:text-center">
        <p class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Get booked by vetted creators nearby you, effortlessly
        </p>
        <p class="mt-6 text-lg leading-8 text-gray-600">
          Boost your social visibility, sustain ongoing virality, and become the hottest spot in your city with continuous
          collaborations on Bulba!
        </p>
      </div>
      <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-y-20 gap-x-5 mt-24">
        <div v-for="creator in creators" :key="creator.username" class="flex items-center justify-center">
          <div class="flex justify-center flex-col items-center w-80">
            <a :href="creator.link" target="_blank" class="w-[100px] h-[100px] block">
              <img :src="creator.profile" class="object-cover">
            </a>
            <span class="block mt-2 font-semibold text-indigo-600 text-center">@{{creator.username}}</span>
            <div class="w-full flex">
              <div class="flex w-full items-center flex-col justify-center">
                <span class="font-semibold">{{creator.followers}}K</span>
                <span class="text-xs">FOLLOWERS</span>
              </div>
              <div class="border-l-[1px] flex w-full items-center flex-col justify-center">
                <span class="font-semibold">{{creator.avgViews}}K</span>
                <span class="text-xs">AVG. VIEWS</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-center text-center w-full">
          <div class="w-32 h-full flex items-center rounded-xl font-semibold">
            <span>And many more...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { getCreators } from '@/services/contentful/client'
import type { ContentfulBrand, ContentfulCreator } from '@/services/contentful/types'

const creators = ref<ContentfulCreator[]>([])

onMounted(async () => {
  creators.value = await getCreators()
})
</script>
